import { useLocation } from 'react-router-dom';
import BottomNav from '@/components/feature/BottomNav';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isAuthPage = location.pathname === '/app/login' || location.pathname === '/app/register';
  // 채팅 상세 페이지(/app/chat?match_id=...)에서만 하단 네비 숨김, 채팅 목록(/app/chat-list)은 네비 표시
  const isChatDetail = location.pathname === '/app/chat';

  return (
    <div className="min-h-screen bg-gray-50 flex justify-center">
      <div className="w-full max-w-md min-h-screen bg-white relative shadow-xl">
        {/* 메인 콘텐츠 */}
        <main className={isAuthPage ? '' : 'pb-20'}>
          {children}
        </main>
        {/* 하단 네비게이션 (인증 페이지, 채팅 상세 페이지 제외) */}
        {!isAuthPage && !isChatDetail && <BottomNav />}
      </div>
    </div>
  );
}